import React, { useEffect } from "react";

import { TOptionValue } from "../option/optionsUtils";
import Toggle from "../option/types/toggle/Toggle";
import "./ToggleContainer.scss";

interface IProps {
    title: React.ReactNode | undefined;
    description: React.ReactNode | undefined;
    value?: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function ToggleContainer(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue>(props.value || "unselected");

    const onClick = (e) => {
        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <div
            onClick={onClick}
            className={`userful-toggle-container noselect ${
                value === "selected"
                    ? "userful-toggle-container-selected"
                    : value === "indeterminate"
                      ? "userful-toggle-container-indeterminate"
                      : ""
            } 
            ${props.disabled ? "userful-toggle-container-disabled" : ""}`}
        >
            <div className="userful-toggle-text">
                <h1>{props.title}</h1>
                <p>{props.description}</p>
            </div>
            <Toggle onClick={onClick} value={value} disabled={props.disabled} />
        </div>
    );
}
